import { SectionId } from './section-id-enum';

export const SECTIONS_WITH_NOTES: Readonly<Readonly<SectionId>[]> = [
  SectionId.b1TipologiaDiProcedura,
  SectionId.c2VerificaRegolaritaDebitiTributariEPrevidenziali,
  SectionId.c3ValutazioneScostamentoRispettoAlPiano,
  SectionId.c4PresenzaPareriEsterni,
  SectionId.c5AnalisiDelBusiness,
  SectionId.regolaritaDeiPagamenti,
  SectionId.d4RecoveryAnalysis,
  SectionId.d5VelocitaESicurezzaDiRecuperoDellEscussioneDellaGaranzia,
];
